import script from "./themeTablePoster.vue?vue&type=script&lang=ts&setup=true"
export * from "./themeTablePoster.vue?vue&type=script&lang=ts&setup=true"

import "./themeTablePoster.vue?vue&type=style&index=0&id=07aa3444&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07aa3444"]])

export default __exports__